import SelectorColor from '@common/ui/selector/SelectorColor';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ColorSwatch from './ColorSwatch';
const ProductSelectionColorExpanded = (props) => {
    var _a;
    const { t } = useTranslation();
    return (React.createElement("div", { className: classNames('selector-color-expanded', { inverted: props.inverted }, props.className), "aria-label": t('product.selectcolor') },
        React.createElement("span", { className: "selector__label" },
            React.createElement("span", { className: "selector__label__name" },
                t('label.color'),
                ":"),
            React.createElement("span", { className: "selector__label__value" }, (_a = props.variationValues.find((variationValue) => variationValue.id === props.currentId)) === null || _a === void 0 ? void 0 : _a.displayValue)),
        React.createElement("div", { className: "selector__menu" }, props.variationValues.map((variation) => {
            if (props.hideOnlineExclusive && variation.isOnlineExclusive) {
                return;
            }
            return (React.createElement(SelectorColor, { key: variation.id, value: variation.id, label: variation.displayValue, disabled: props.alwaysAvailable || (variation === null || variation === void 0 ? void 0 : variation.isBoutiqueExclusive) ? false : !variation.selectable && !window.unshoppable && !props.boutiqueAvailability, selected: variation.value == props.currentId, isOutOfStock: variation.selectable, item: variation, onSelect: (variation) => {
                    props.onChangeVariation(variation);
                }, productUuid: props.productUuid, isNotAvailableSelectable: props.isNotAvailableSelectable, isBoutiqueExclusive: props.isBoutiqueExclusive },
                React.createElement(ColorSwatch, { variation: variation, ariaHidden: true }),
                !props.boutiqueAvailability && React.createElement("span", { className: "stroke" })));
        }))));
};
ProductSelectionColorExpanded.defaultProps = {
    variationValues: [],
};
export default ProductSelectionColorExpanded;
